import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type WalletProps = IconProps;
export const Wallet = ({ className, ...props }: WalletProps) => (
  <Icon
    className={classNames('wallet', className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <rect x="2" y="2.5" width="20" height="19" rx="3.339" stroke="currentColor" strokeWidth="1.8" />
    <rect x="4.728" y="5.295" width="14.546" height="1.8" rx=".879" fill="currentColor" />
    <path
      d="M17.454 12.336c-.26 0-.513.093-.715.262a1.16 1.16 0 0 0-.39.667 1.18 1.18 0 0 0 .111.77c.123.236.322.42.563.523.241.102.51.116.759.038a1.13 1.13 0 0 0 .61-.464 1.176 1.176 0 0 0-.14-1.458l-.026.027.026-.027a1.122 1.122 0 0 0-.798-.338z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".5"
    />
  </Icon>
);
